<template>
    <div>
        <CRow>
            <CCol col="12">
                <CCard>
                    <CCardHeader>
                        <strong>Создание услуги</strong>
                    </CCardHeader>

                    <CCardBody>
                        <AssistantServiceUpsertForm
                            @success="$router.push(`/assistants/${$route.params.id}/service`)"
                            @dismiss="$router.go(-1)"
                        />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import AssistantServiceUpsertForm from '@/components/assistant/AssistantServiceUpsertForm'

    export default {
        name: 'AssistantServiceCreate',

        components: {
            AssistantServiceUpsertForm,
        },
    }
</script>

<style>

</style>
